import React from 'react';
import { TableRow, TableCell, TableBody } from '@one-thd/sui-atomic-components';
import { Checkmark } from '@one-thd/sui-icons';
import { useConfigService } from '@thd-nucleus/experience-context';
import { TableHeader } from './table-header';
export var PaymentMethodsTableContent = function (_a) {
    var isEnrolled = _a.isEnrolled;
    var enablePHAPermissions = !!useConfigService('ENABLE_PHA_PERMISSIONS');
    return (React.createElement(React.Fragment, null,
        React.createElement(TableHeader, { title: "Payment Methods", showRunner: isEnrolled }),
        React.createElement(TableBody, null,
            isEnrolled && (React.createElement(React.Fragment, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Pay with assigned Pro Allowance"),
                    React.createElement(TableCell, { align: "center", width: "full" },
                        React.createElement(Checkmark, null)),
                    React.createElement(TableCell, { align: "center", width: "full" },
                        React.createElement(Checkmark, null)),
                    isEnrolled && (React.createElement(TableCell, { align: "center", width: "full" },
                        React.createElement(Checkmark, null)))),
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Assign Pro Allowance"),
                    React.createElement(TableCell, { align: "center", width: "full" },
                        React.createElement(Checkmark, null)),
                    React.createElement(TableCell, { width: "full" }),
                    isEnrolled && React.createElement(TableCell, { width: "full" })))),
            enablePHAPermissions && (React.createElement(React.Fragment, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Pay with Pro Trade Credit"),
                    React.createElement(TableCell, { align: "center", width: "full" },
                        React.createElement(Checkmark, null)),
                    React.createElement(TableCell, { align: "center", width: "full" },
                        React.createElement(Checkmark, null)),
                    isEnrolled && React.createElement(TableCell, { width: "full" })),
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Assign Pro Trade Credit"),
                    React.createElement(TableCell, { align: "center", width: "full" },
                        React.createElement(Checkmark, null)),
                    React.createElement(TableCell, { width: "full" }),
                    isEnrolled && React.createElement(TableCell, { width: "full" })))),
            React.createElement(TableRow, null,
                React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Add payment methods"),
                React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)),
                React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)),
                isEnrolled && React.createElement(TableCell, { width: "full" })),
            React.createElement(TableRow, null,
                React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Manage payment methods added by other users"),
                React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)),
                React.createElement(TableCell, { width: "full" }),
                isEnrolled && React.createElement(TableCell, { width: "full" })))));
};
